import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenter } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { IconType, SvgIcon } from '../../Zemplin/General/SvgIcon';

interface Props {
  color: string;
  text: string;
  icon: IconType;
}

function Status({ color, text, icon }: Props) {
  return (
    <Wrapper color={color}>
      <SvgIcon icon={icon} alt="" title="" fill={color} marginRight={8} />
      <Text color={color}>{text}</Text>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenter)<{ color: string }>`
  border: ${({ color }) => `2px solid ${color}`};
  padding: 0 ${rem(16)};
  border-radius: ${rem(24)};
  height: ${rem(48)};

  ${({ theme }) => theme.mediab.m810`
     border: 0;
     padding: 0;
     height: ${rem(24)};
     margin-top: ${rem(4)};
  `};
`;

const Text = styled(TextP)<{ color: string }>`
  color: ${({ color }) => color};
  font-family: ${({ theme }) => theme.font.secondaryLight};
  font-weight: 400;
  font-size: ${rem(14)};
  line-height: ${rem(22)};

  ${({ theme }) => theme.mediab.m810`
  `};
`;

export { Status };
